import { render, staticRenderFns } from "./baseStepForm.vue?vue&type=template&id=688c64ea&scoped=true"
import script from "./baseStepForm.vue?vue&type=script&lang=js"
export * from "./baseStepForm.vue?vue&type=script&lang=js"
import style0 from "./baseStepForm.vue?vue&type=style&index=0&id=688c64ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688c64ea",
  null
  
)

export default component.exports